import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const agreeTermsReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_AGREE_TERMS:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_AGREE_TERMS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_AGREE_TERMS_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_AGREE_TERMS:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default agreeTermsReducer;
